/* eslint-disable */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { history } from "../../config/stores";
import { setHeaderStatus } from "../../actions";
import News, { findArticleBySlug } from "../../config/NewsText";
import { useIsMobile } from "../../utilities/useIsMobile";
import "./styles.scss";

// Helper to get description from article parts
const getArticleDescription = (parts) => {
  if (!parts || parts.length === 0) return "Fidweb - Making software people actually love";
  const firstPart = parts[0];
  const stripped = firstPart.replace(/<[^>]*>/g, '').replace(/className='[^']*'/g, '');
  return stripped.length > 160 ? stripped.substring(0, 157) + "..." : stripped;
};

const getAbsoluteImageUrl = (image) => {
  if (!image) return "https://fidweb.net/screenshot.png";
  if (image.startsWith('http')) return image;
  return `https://fidweb.net${image}`;
};

const convertToHtml = (htmlString) => {
  if (!htmlString) return htmlString;
  return htmlString.replace(/className=/g, 'class=');
};

const handleBackFromArticle = (setHeaderStatus) => {
  setHeaderStatus("Software Development");
  const footer = document.getElementById("footer");
  if (footer) footer.classList.remove("disable");
};

const Article = ({ setHeaderStatus }) => {
  const isMobile = useIsMobile();
  const slug = window.location.pathname.split("/")[2];
  
  let article = findArticleBySlug(slug);
  let articleIndex = article ? article.index : null;
  
  if (!article && !isNaN(parseInt(slug))) {
    articleIndex = parseInt(slug);
    article = News[articleIndex];
  }
  
  if (!article) {
    article = {};
  }

  useEffect(() => {
    if (!isMobile) {
      const footer = document.getElementById("footer");
      if (footer) {
        footer.classList.add("disable");
        footer.style.display = "none";
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [isMobile]);

  const articleTitle = article.title || "Fidweb Article";
  const articleDescription = getArticleDescription(article.parts);
  const articleImage = getAbsoluteImageUrl(article.image);
  const articleUrl = `https://fidweb.net/article/${article.slug || slug}`;

  const rightPanelClass = [
    "right-article-container",
    article.special && "special",
    article.html && "html-article",
  ].filter(Boolean).join(" ");

  return (
    <>
      <Helmet>
        <title>{articleTitle} | Fidweb</title>
        <meta name="description" content={articleDescription} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={articleUrl} />
        <meta property="og:title" content={articleTitle} />
        <meta property="og:description" content={articleDescription} />
        <meta property="og:image" content={articleImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={articleUrl} />
        <meta name="twitter:title" content={articleTitle} />
        <meta name="twitter:description" content={articleDescription} />
        <meta name="twitter:image" content={articleImage} />
      </Helmet>

      <div className="only-mobile">
        <div className="mobile-article-container">
          <Link
            to="/news"
            className="mobile-arrow-left"
            aria-label="Back to news"
            onClick={() => handleBackFromArticle(setHeaderStatus)}
          />
          <div className="mobile-neshto" style={{ paddingBottom: "20px" }}>
            {article.logo && (
              <div
                className="logo"
                style={{
                  backgroundImage: `url(${article.logo})`,
                }}
              />
            )}
            <img src={article.image} alt={article.title} />
            <h3 style={{ fontSize: "20px", marginLeft: "6%", marginTop: "2%" }}>{article.title}</h3>

            {article.parts && article.parts.map((part, index) => {
              return article.html ? (
                <div
                  key={index}
                  className={`mobile-article-text ${part.includes("no-padding") ? "no-padding" : ""} ${part.includes("no-margin") ? "no-margin" : ""} ${part.includes("bulletpoint") ? "bulletpoint" : ""}`}
                  dangerouslySetInnerHTML={{ __html: convertToHtml(part) }}
                />
              ) : (
                <div key={index} className="mobile-article-text">{part}</div>
              );
            })}
            <div className={`icons-container ${article?.images ? "images-logos" : ""}`}>
              {article.apple && <div className={`apple-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.apple)} />}
              {article.play && <div className={`play-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.play)} />}
              {article.site && <div className="site-icon" onClick={() => window.open(article.site)} />}
              {article?.images &&
                article?.images?.map((el, index) => {
                  return <div key={index} className={`logo-icon-${el.logo}`} onClick={() => window.open(el?.link)} />;
                })}
            </div>
          </div>
        </div>
      </div>

      <div className="only-desktop">
        <div className="article-container">
          <div className="left-article-container">
            <div
              className="arrow-left"
              onClick={() => {
                history.push("/");
                handleBackFromArticle(setHeaderStatus);
              }}
            />
            <div className="neshto">
              {article.logo && (
                <div
                  className="logo"
                  style={{
                    backgroundImage: `url(${article.logo})`,
                  }}
                />
              )}

              <h2>{article.title}</h2>

              {article.parts && article.parts.map((part, partIndex) => {
                return article.html ? (
                  <div key={partIndex} className={`article-text ${part.includes("no-padding") ? "no-padding" : ""} ${part.includes("no-margin") ? "no-margin" : ""} ${part.includes("bulletpoint") ? "bulletpoint" : ""} ${part.includes("medium") ? "medium" : ""} ${part.includes("last") ? "last" : ""}`} dangerouslySetInnerHTML={{ __html: convertToHtml(part) }}></div>
                ) : article?.video && partIndex === 2 ? (
                  <>
                    <div
                      className="video-image video"
                      onClick={() => {
                        window.open(article?.video);
                      }}
                    />
                    <div className="article-text">{part}</div>
                  </>
                ) : (
                  <div key={partIndex} className="article-text">{part}</div>
                );
              })}
              <div className={`icons-container ${article?.images ? "images-logos" : ""}`}>
                {article.apple && <div className={`apple-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.apple)} />}
                {article.play && <div className={`play-icon ${article.title?.includes("Scoutify") && "scoutify"}`} onClick={() => window.open(article.play)} />}
                {article.site && <div className="site-icon" onClick={() => window.open(article.site)} />}
                {article?.images &&
                  article?.images?.map((el, index) => {
                    return <div key={index} className={`logo-icon-${el.logo}`} onClick={() => window.open(el?.link)} />;
                  })}
              </div>
            </div>
          </div>
          <div
            className={rightPanelClass}
            style={{
              backgroundPosition: article.resize ? 'unset' : 'center',
              backgroundImage: `url(${article.image})`,
            }}
          ></div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  headerStatus: state.stateControl.headerStatus,
});

const mapDispatchToProps = (dispatch) => ({
  setHeaderStatus: (payload) => dispatch(setHeaderStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Article);
